'use client';

import { Buildings } from '@phosphor-icons/react';
import { LegalPageLayout } from '@/components/legal/legal-page-layout';

const BulletList = ({ items }: { items: string[] }) => (
  <ul className="space-y-1.5 pl-1">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-2">
        <span className="mt-1.5 w-1 h-1 rounded-pill bg-[var(--primary)] flex-shrink-0" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

export function RentContent() {
  const sections = [
    {
      title: '1. Общая информация',
      content: (
        <p>
          Наша компания рассматривает предложения по аренде объектов недвижимости для размещения торговых точек и заведений общественного питания.
        </p>
      ),
    },
    {
      title: '2. Требования к объектам',
      content: (
        <BulletList items={[
          'Объект должен быть расположен на первом или втором этаже',
          'Площадь объекта 50–300 кв.м.',
          'Желаемая ширина помещения не менее 5 метров',
          'Перепад высоты пола не более 40 см, высота потолка не ниже 3 метров',
          'Удобный подъезд к узлу разгрузки товара (не менее 1 автомобиля)',
          'Электрическая мощность не менее 40 кВт или возможность увеличения',
          'Системы отопления, водоснабжения и канализации в рабочем состоянии. Температура в помещении не менее 10°С',
        ]} />
      ),
    },
    {
      title: '3. Требования к арендованным помещениям',
      content: (
        <BulletList items={[
          'Без ограничений по режиму работы (стандартный режим: 24 часа ежедневно)',
          'Возможность перепланировки (расширение проёмов, увеличение торговой площади, электрических мощностей и т.д.)',
          'Отсутствие задолженностей по оплате коммунальных услуг',
        ]} />
      ),
    },
    {
      title: '4. Расположение объектов',
      content: (
        <BulletList items={[
          'В спальных и центральных районах города',
          'В мини-торговых центрах с удобной локацией',
          'Отдельно стоящие здания нежилого типа',
          'Рядом или в крупных торговых центрах (универмагах)',
          'Желательно наличие парковки для автомобилей курьеров у входа на объект',
        ]} />
      ),
    },
    {
      title: '5. Как предложить объект',
      content: (
        <p>
          Для оценки вашего объекта недвижимости просим предоставить информацию на адрес электронной почты с подробной фотофиксацией и описанием объекта:{' '}
          <a href="mailto:aziabox@inbox.ru" className="text-[var(--primary)] font-medium hover:underline">aziabox@inbox.ru</a>
        </p>
      ),
    },
  ];

  return (
    <LegalPageLayout
      title="Арендодателям"
      icon={<Buildings className="w-3.5 h-3.5 text-[var(--primary)]" weight="fill" />}
      sections={sections}
      contactBlock={
        <div className="text-sm text-[var(--text-secondary)]">
          <p>Предложения по аренде:</p>
          <a href="mailto:aziabox@inbox.ru" className="text-[var(--primary)] font-medium hover:underline">aziabox@inbox.ru</a>
        </div>
      }
    />
  );
}
